import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../../api/queries/homeQueries";
import Utils from "../../../utils/utils";
import MusicalCard from "../../../components/box/MusicalCard";
import { UI } from "../../../config/ui";
import { UiTitle } from "../../../components/text/UiTitle";
import { useTranslationEx } from "../../../hooks/useTranslationEx";

// interface MusicalSwiperProps {}

interface MusicalSwiperProps {}

const MusicalSwiper: React.FC<MusicalSwiperProps> = () => {
  const { handleSlideChange, products } = useHomeProducts(
    "MUSICAL",
    "musicals",
  );
  const { t } = useTranslation();
  const { t2 } = useTranslationEx({});
  return (
    <div className="flex w-full flex-col justify-center gap-4 sm:gap-10">
      <UiTitle text={t("Musical")} />
      <div className="w-full">
        <div className="relative">
          {!!products?.length && (
            <Swiper
              initialSlide={2}
              slidesPerView={"auto"}
              spaceBetween={16}
              breakpoints={{
                [UI.sm]: {
                  slidesPerView: 4,
                  spaceBetween: Utils.remToPx(1.5),
                },
              }}
              centeredSlides={true}
              loop={true}
              className="musical-swiper"
              onSlideChange={handleSlideChange}
            >
              {products.map((musical, index) => (
                <SwiperSlide key={index}>
                  <a
                    className="h-full w-full"
                    href={`/musicals/${musical.slug}`}
                  >
                    <MusicalCard
                      id={musical.id}
                      img={musical.thumbnail}
                      name={t2(musical.name)}
                      location={musical.cityName || t("Unknown Location")}
                      price={musical.price}
                      originalPrice={musical.originalPrice}
                    />
                  </a>
                </SwiperSlide>
              ))}
              {products?.length < 6 && products?.length >= 4 && (
                <>
                  {products.map((musical, index) => (
                    <SwiperSlide key={index}>
                      <a
                        className="h-full w-full"
                        href={`/musicals/${musical.id}`}
                      >
                        <MusicalCard
                          id={musical.id}
                          img={musical.thumbnail}
                          name={t2(musical.name)}
                          location={musical.cityName || t("Unknown Location")}
                          price={musical.price}
                          originalPrice={musical.originalPrice}
                        />
                      </a>
                    </SwiperSlide>
                  ))}
                </>
              )}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
};

export default MusicalSwiper;
